angular.module("vgresiduos").controller("SupplierEditCtrl", [
	"$rootScope",
	"$stateParams",
	function ($rootScope, $stateParams) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `organizacao/fornecedor/${$stateParams.id}`, getQueries());
		};

		function getQueries() {
			const queries = [];
			if ($stateParams.tab) {
				queries.push({ key: "tab", value: $stateParams.tab });
			}
			if ($stateParams.openCreateDocument) {
				queries.push({ key: "openCreateDocument", value: $stateParams.openCreateDocument });
			}
			if ($stateParams.utmSource) {
				queries.push({ key: "utmSource", value: $stateParams.utmSource });
			}
			if ($stateParams.disposalModelId) {
				queries.push({ key: "disposalModelId", value: $stateParams.disposalModelId });
			}
			return queries;
		}
	}
]);
